export default "__VITE_ASSET__ljXUdJae__"